import { string } from '@iwentsourcing/core/typing/string.js';
import { TypeOfEvent } from '@iwentsourcing/core/typing/type-of.js';
import { declareEvent } from '@iwentsourcing/core/storage/declare-event.js';

export const IncompleteTodoEvent = declareEvent('incomplete-todo', {
  id: string(),
});
export type IncompleteTodoEvent = TypeOfEvent<typeof IncompleteTodoEvent>;
